import React, { Component } from "react";
import OdoslanieNeexpedovaneBalikyPalety from "./Home/OdoslanieNeexpedovaneBalikyPalety";
import SpravyDotaz from "./Home/SpravyDotaz";
import NahlasenieNenahlaseneDodavky from "./Home/NahlasenieNenahlaseneDodavky";

class Home extends Component {
    displayName = Home.name;

    state = {
        balik: null,
        shouldReloadSpravyDotaz: false,
        shouldReloadOdoslanieNeexpedovaneBalikyPalety: false,
        shouldReloadNahlasenieNenahlaseneDodavky: false,
        keyboardEventHandlerDisabled: false
    };

    reloadHomePageGrids = () => {
        this.setState({
            shouldReloadSpravyDotaz: true,
            shouldReloadOdoslanieNeexpedovaneBalikyPalety: true,
            shouldReloadNahlasenieNenahlaseneDodavky: true
        });
    };

    reloadSpravyGrid = () => {
        this.setState({
            shouldReloadSpravyDotaz: true
        });
    };

    reloadOdoslanieGrids = () => {
        this.setState({
            shouldReloadSpravyDotaz: true,
            shouldReloadOdoslanieNeexpedovaneBalikyPalety: true
        });
    };

    reloadNahlasenieGrids = () => {
        this.setState({
            shouldReloadSpravyDotaz: true,
            shouldReloadNahlasenieNenahlaseneDodavky: true
        });
    };

    switchKeyboardEventHandler = isDisabled => {
        this.setState({ keyboardEventHandlerDisabled: isDisabled });
        console.debug(`Home.switchKeyboardEventHandler => isDisabled = ${isDisabled}`);
    };

    render() {
        return (
            <div className="wrapper wrapper-content">
                <div className="row">
                    <div className="col-lg-6">
                        <SpravyDotaz
                            switchKeyboardEventHandler={this.switchKeyboardEventHandler}
                            reloadHomePageGrids={this.reloadHomePageGrids}
                            reloadOdoslanieGrids={this.reloadOdoslanieGrids}
                            reloadNahlasenieGrids={this.reloadNahlasenieGrids}
                            shouldReloadGrid={this.state.shouldReloadSpravyDotaz}
                            afterReload={() => this.setState({ shouldReloadSpravyDotaz: false })}
                        />
                    </div>
                    <div className="col-lg-6">
                        <OdoslanieNeexpedovaneBalikyPalety
                            switchKeyboardEventHandler={this.switchKeyboardEventHandler}
                            reloadSpravyGrid={this.reloadSpravyGrid}
                            shouldReloadGrid={this.state.shouldReloadOdoslanieNeexpedovaneBalikyPalety}
                            afterReload={() => this.setState({ shouldReloadOdoslanieNeexpedovaneBalikyPalety: false })}
                        />
                        <NahlasenieNenahlaseneDodavky
                            switchKeyboardEventHandler={this.switchKeyboardEventHandler}
                            keyboardEventHandlerDisabled={this.state.keyboardEventHandlerDisabled}
                            reloadSpravyGrid={this.reloadSpravyGrid}
                            shouldReloadGrid={this.state.shouldReloadNahlasenieNenahlaseneDodavky}
                            afterReload={() => this.setState({ shouldReloadNahlasenieNenahlaseneDodavky: false })}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/views/Home.js